ion-header {
  display: block;
  position: relative;
  order: -1;
  width: 100%;
  z-index: 10;
}

ion-header ion-toolbar:first-of-type {
  padding-top: var(--ion-safe-area-top, 0);
}

.header-md::after {
  left: 0;
  bottom: -5px;
  background-position: left 0 top -2px;
  position: absolute;
  width: 100%;
  height: 5px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAHBAMAAADzDtBxAAAAD1BMVEUAAAAAAAAAAAAAAAAAAABPDueNAAAABXRSTlMUCS0gBIh/TXEAAAAaSURBVAjXYxCEAgY4UIICBmMogMsgFLtAAQCNSwXZKOdPxgAAAABJRU5ErkJggg==);
  background-repeat: repeat-x;
  content: "";
}
[dir=rtl] .header-md::after, :host-context([dir=rtl]) .header-md::after {
  left: unset;
  right: unset;
  right: 0;
}

[dir=rtl] .header-md::after, :host-context([dir=rtl]) .header-md::after {
  background-position: right 0 top -2px;
}

.header-collapse-condense {
  display: none;
}

.header-md.ion-no-border::after {
  display: none;
}